import React, {useReducer, useMemo, useState} from "react";
import { InputText } from "../../_components/InputText/InputText";
import { Button } from "@mui/material";
import styles from "../../_components/Styles/BaseStyleForAdminPanel.module.css";
import {UserCreate} from "../../../../types/api/authorization/user.types";
import useAppSnackbar from "../../../../hooks/useAppSnackbar";
import {useFetchAllPositions} from "../../../../hooks/authorization/useFetchAllPositions";
import {useFetchAllRights} from "../../../../hooks/authorization/useFetchAllRights";
import OpenCheckboxList from "../../_components/OpenCheckboxList/OpenCheckboxList";
import {userService} from "../../../../services/authorization/user-service";

interface UserState extends UserCreate{
}

export const CreateUser = () => {
    const {showSuccess, showError, SnackbarComponent} = useAppSnackbar();
    const initialState: UserState = {
        name: "",
        surname: "",
        lastname: "",
        login: "",
        password: "",
        email:"",
        positions: [],
        rights: [],
    };

    const {
        data: positionsData
    } = useFetchAllPositions();

    const {
        data: rightsData
    } = useFetchAllRights();

    const reducer = (state: UserState, action: any) => {
        switch (action.type) {
            case "SET_FIELD":
                return { ...state, [action.name]: action.value };
            case "RESET":
                return action.initialState;
            default:
                return state;
        }
    };

    const [state, dispatch] = useReducer(reducer, initialState);

    const handleValue = (e: any) => {
        const target = e.target;
        dispatch({ type: "SET_FIELD", name: target.name, value: target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await userService.create(state);
            showSuccess("Пользователь успешно создан");
        }catch (e){
            console.log("Submitting:", state);
            showError("Произошла ошибка при сохранении пользователя")
        }
    };

    const [positionSearch, setPositionSearch] = useState<string>("");
    const [rightsSearch, setRightsSearch] = useState<string>("");

    const filteredPositions = useMemo(() => {
        const q = positionSearch.trim().toLowerCase();
        if (!q) return positionsData ?? [];
        return (positionsData ?? []).filter(p => (p.title ?? "").toLowerCase().includes(q));
    }, [positionSearch, positionsData]);

    const filteredRights = useMemo(() => {
        const q = rightsSearch.trim().toLowerCase();
        if (!q) return rightsData ?? [];
        return (rightsData ?? []).filter(r => (r.title ?? "").toLowerCase().includes(q));
    }, [rightsSearch, rightsData]);

    return (
        <form className={styles.formWrapper} onSubmit={handleSubmit}>
            <div className={styles.formCard}>
                <div className={styles.formHeader}>
                    <h2 className={styles.formTitle}>Создание пользователя</h2>
                    <p className={styles.formSubtitle}>Заполните информацию о пользователе</p>
                </div>

                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <h3 className={styles.sectionTitle}>Основная информация</h3>
                    </div>
                    <div className={styles.inputsGrid}>
                        <InputText
                            name="name"
                            value={state.name}
                            handleValue={handleValue}
                            label="Имя"
                            idField="name"
                            required
                        />
                        <InputText
                            name="surname"
                            value={state.surname}
                            handleValue={handleValue}
                            label="Фамилия"
                            idField="surname"
                            required
                        />
                        <div className={styles.fullRow}>
                            <InputText
                                name="lastname"
                                value={state.lastname}
                                handleValue={handleValue}
                                label="Отчество"
                                idField="lastname"
                                required
                            />
                        </div>
                    </div>
                    <hr className={styles.sectionDivider} />
                </div>

                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <h3 className={styles.sectionTitle}>Учетные данные</h3>
                    </div>
                    <div className={styles.inputsGrid}>
                        <InputText
                            name="login"
                            value={state.login}
                            handleValue={handleValue}
                            label="Логин"
                            idField="login"
                            required
                        />
                        <InputText
                            name="email"
                            value={state.email}
                            handleValue={handleValue}
                            label="Почта"
                            idField="email"
                            required
                        />
                        <div className={styles.fullRow}>
                            <InputText
                                name="password"
                                value={state.password}
                                handleValue={handleValue}
                                label="Пароль"
                                idField="password"
                                typeFiled="password"
                                required
                            />
                        </div>
                    </div>
                    <hr className={styles.sectionDivider} />
                </div>

                <div className={styles.section}>
                    <div className={styles.inputsGrid}>
                        <OpenCheckboxList
                            label="Должности"
                            name="positions"
                            options={(filteredPositions ?? []).map(p => ({ value: p.id, label: p.title }))}
                            selected={state.positions as string[]}
                            onChange={handleValue}
                            searchValue={positionSearch}
                            onSearchChange={setPositionSearch}
                        />

                        <OpenCheckboxList
                            label="Права"
                            name="rights"
                            options={(filteredRights ?? []).map(r => ({ value: r.id, label: r.title }))}
                            selected={state.rights as string[]}
                            onChange={handleValue}
                            searchValue={rightsSearch}
                            onSearchChange={setRightsSearch}
                        />
                    </div>
                </div>

                <div className={styles.btn}>
                    <Button
                        type="submit"
                        className={`${styles.buttonBase} ${styles.buttonPrimary}`}
                    >
                        Создать
                    </Button>
                </div>
            </div>
            <SnackbarComponent />
        </form>
    );
};

export default CreateUser;